import { render, staticRenderFns } from "./SearchRenderer.vue?vue&type=template&id=06e2816e&scoped=true"
import script from "./SearchRenderer.vue?vue&type=script&lang=js"
export * from "./SearchRenderer.vue?vue&type=script&lang=js"
import style0 from "./SearchRenderer.vue?vue&type=style&index=0&id=06e2816e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2816e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e2816e')) {
      api.createRecord('06e2816e', component.options)
    } else {
      api.reload('06e2816e', component.options)
    }
    module.hot.accept("./SearchRenderer.vue?vue&type=template&id=06e2816e&scoped=true", function () {
      api.rerender('06e2816e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SchemaTablePage/SearchRenderer.vue"
export default component.exports